import React from 'react'
import { Badge } from 'antd'
import { useSelector } from 'react-redux'

import { getCompanyById } from '../../../../utils'

const Status = () => {
  const companies = useSelector(s => s._auth.business_accounts)
  const selected = localStorage.getItem('app.settings.company')
  const company = getCompanyById(companies, selected)

  const { status } = company

  const color = status === 'active' ? 'green' : 'red'

  return (
    company.length > 0 && (
      <>
        <Badge color={color} />
        <span className="text-muted" style={{ marginLeft: '3px' }}>
          {status}
        </span>
      </>
    )
  )
}

export default Status
